import React, { useEffect } from "react";
import "./inventoryManagement.css";
import inventory_img1 from "assets/inventory/inventory1.png";
import inventory_img2 from "assets/inventory/inventory2.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const ProjectTowerUnit = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Inventory Project Tower Unit | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Provide Customers Real-Time Access to Your Real Estate Inventory"
              subTitle="The Realtor Desk empowers you to offer a transparent and convenient customer experience by providing real-time access to your real estate inventory, ensuring that clients always have up-to-date information at their fingertips."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Easier Real Estate Inventory Management with The Realtor Desk CRM"
                description="Homebuyers value trust, and The Realtor Desk helps you build that trust with its intuitive online inventory management features. By providing all inventory details at the click of a button, it ensures transparency and simplicity, making it easier for you to manage and communicate with customers effectively."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Complete Inventory from Projects to Towers to Units"
                title="Full Inventory Access for a Better Customer Experience"
                description="The Realtor Desk provides your prospects with complete access to all inventory—from projects to towers to individual units—updated in real time. This ensures customers have the information they need to make informed decisions and confidently book properties, knowing they are selecting from the best options based on their specific requirements."
                image={inventory_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="New, Resale, and Rental"
                title="New, Resale, and Rental Support"
                description="The Realtor Desk offers comprehensive support for new, resale, and rental properties, along with multi-developer support. It provides easy access to floor plans, brochures, and other assets, helping you manage inventory with features like one-click access to find matching leads, holding, blocking, and booking inventory, as well as managing parking and allied inventory."
                image={inventory_img2}
                imagePosition="left"
            />
          </div>
      </div>
    </>
  );
};

export default ProjectTowerUnit;
